import React from 'react';
import { Navigate } from 'react-router-dom';

// --- Layouts ---
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import NotFoundView from 'src/views/errors/NotFoundView';

// --- Auth at dashboard ---
import LoginView from 'src/views/auth/LoginView';
import Dashboard from 'src/views/dashboard';
import BannerAndCover from 'src/views/ImageBannerCover';

// --- Auctions ---
import AuctionCreate from 'src/views/auction/create';
import AuctionSet from 'src/views/auction/auctionSet';
import AuctionsList from 'src/views/auction/list';
import AuctionsViewDetails from 'src/views/auction/details';
import AuctionsViewLots from 'src/views/auction/viewLots';
import AuctionsUploadLots from 'src/views/auction/UploadMultiple';
import AuctionsImportLots from 'src/views/auction/excelImport';
import AuctionsEditSetup from 'src/views/auction/edit';
import UpdateHPandBP from 'src/views/auction/updateHpandBp';
import Reserve from 'src/views/auction/Reserve';

import MenuLogs from 'src/views/auction/lot-details';
import Lot from 'src/views/auction/lots';


// --- Users ---
import UserCreate from 'src/views/User/create';
import UserList from 'src/views/User/list';
import UserViewDetails from 'src/views/User/details';

// --- Private sale ---
import PrivateSaleList from 'src/views/privateSale/list';
import PrivateSaleCreate from 'src/views/privateSale/create';
import PrivateSaleEdit from 'src/views/privateSale/edit';
import PrivateSaleSetting from 'src/views/privateSale/setting';

// --- Exhibitions ---
import ExhibitionsCreate from 'src/views/exhibitions/create';
import ExhibitionsList from 'src/views/exhibitions/list';
import ExhibitionArtistEdit from 'src/views/exhibitions/edit_exhibition';
import ExhibitionEdit from 'src/views/exhibitions/edit';
import ExhibitionItem from 'src/views/exhibitions/item';
import ExhibitionAddItem from 'src/views/exhibitions/addItem';

// --- Settings at announcements ---
import SettingBannerList from 'src/views/settings/bannerList';
import Message from 'src/views/settings/message';

// --- Reports ---
import Receipt from 'src/views/reports/receipt';
import ReceiptPrint from 'src/views/reports/receipt/print';

import Consignment from 'src/views/reports/consignment';

import Commission from 'src/views/reports/commission';

import Custom from 'src/views/reports/custom';
import Sticker from 'src/views/reports/sticker';
import Private from 'src/views/reports/private';

import Certificate from 'src/views/reports/certificate';
import Releasing from 'src/views/reports/releasing';
import Invoice from 'src/views/accounting/invoice';

// --- Invoice processing ---
import FindInvoice from 'src/views/Invoice/list';
import ProcessInvoiceRoutes from 'src/views/Invoice/details';
import AR from 'src/views/accounting/AR';
// --- Live auction console ---
import Declarator from 'src/views/declarator/console';
import JoinRoom from 'src/views/declarator/joinRoom';
//CustomerList
import CustomerList from 'src/views/customerList';
/**
 * Routes ng buong app.
 *
 * MAHALAGA: relative ang path ng bawat child -- walang leading slash.
 * Kinakabit ito sa path ng magulang, kaya:
 *
 *     { path: 'app', children: [{ path: 'dashboard' }] }  ->  /app/dashboard
 *
 * Absolute path ("/dashboard") ang dating gamit dito. Pinapayagan iyon ng
 * react-router-dom 6.0.0-beta, pero ERROR na sa 6.3 stable:
 * "Absolute route path '/dashboard' nested under path 'app' is not valid."
 * Hindi nagbago ang aktwal na URL -- pareho pa rin ang lalabas sa browser.
 */
const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'dashboard', element: <Dashboard /> }, // dashboard ng admin
      { path: 'product/create', element: <BannerAndCover /> }, // pang create ng banner cover

      // --- Auctions ---
      { path: 'auctions/create/room', element: <AuctionCreate /> }, // pagcreate ng auction room
      { path: 'auctions/set', element: <AuctionSet /> }, // pagsetup ng auction, hindi pa tapos
      { path: 'auctions/list', element: <AuctionsList /> }, // auction list page
      { path: 'auctions/view/details/:auctionName/:id', element: <AuctionsViewDetails /> },
      { path: 'auctions/view/lots/:auctionName/:auctionId/:setId', element: <AuctionsViewLots /> }, // pag view ng lots details
      { path: 'auctions/import/lots/:auctionId/:setId', element: <AuctionsImportLots /> }, // import ng image para ma-upload sa auction
      { path: 'auctions/setup/edit/:auctionName/:title/:auctionId/:setId/:id', element: <AuctionsEditSetup /> }, // setup at edit ng auction
      { path: 'auctions/upload/lots/:auctionId/:setId', element: <AuctionsUploadLots /> }, // pag-upload ng mga lots
      { path: 'update/lot/hpandBp', element: <UpdateHPandBP /> }, // update ng hammer price at buyer premium
      { path: 'update/reserve', element: <Reserve /> }, // update ng reserve
     
      { path: 'lot/explore/:eventName/:lotNumber/:eventId/:something/:lotId', element: <MenuLogs /> },
      { path: 'find/lot', element: <Lot /> },

      // --- Users ---
      { path: 'user/create', element: <UserCreate /> }, // pag create ng user
      { path: 'user/list', element: <UserList /> }, // list ng mga user
      { path: 'user/view/details/:first/:last/:id', element: <UserViewDetails /> }, // details ng user

      // --- Private sale ---
      { path: 'private/list', element: <PrivateSaleList /> }, // private list page
      { path: 'private/create', element: <PrivateSaleCreate /> }, // pagcreate ng private item
      { path: 'private/edit/:artist/:id', element: <PrivateSaleEdit /> }, // pag-update ng private item
      { path: 'private/setting', element: <PrivateSaleSetting /> }, // pag-upload ng banner

      // --- Settings ---
      { path: 'setting/banner/list', element: <SettingBannerList /> }, // banner list, dito rin ina-update
      { path: 'setting/message', element: <Message /> }, // setup ng message para sa live auction
   
      // --- Exhibitions ---
      // TANDAAN: mali ang spelling ng URL ("exihibitions" at "exhibtion").
      // Hindi ito binago para hindi masira ang mga naka-bookmark na link.
      { path: 'exihibitions/list', element: <ExhibitionsList /> }, // exhibition list page
      { path: 'exihibitions/create', element: <ExhibitionsCreate /> }, // pag create ng exhibition
      { path: 'exihibitions/edit/:artist/:id', element: <ExhibitionArtistEdit /> }, // pag edit ng artist
      { path: 'exhibtion/edit/:name/:id', element: <ExhibitionEdit /> }, // pag edit ng exhibition
      { path: 'exhibtion/view/item/:name/:id', element: <ExhibitionItem /> }, // pag view ng exhibition item
      { path: 'exhibtion/add/item/:id', element: <ExhibitionAddItem /> }, // pag add ng item sa exhibition

  
      // --- Reports ---
      { path: 'receipt/certificate/invoice/create', element: <Receipt /> }, // pagcreate ng certificate at invoice
   
  
      { path: 'report/consignment', element: <Consignment /> }, // pag add ng consignment
      { path: 'report/commission', element: <Commission /> }, // create ng report para sa commission
      { path: 'report/certificate', element: <Certificate /> },
      { path: 'report/custom', element: <Custom /> }, // create custom reports
      { path: 'report/sticker', element: <Sticker /> }, // create sticker
      { path: 'report/private', element: <Private /> }, // create private reports
      { path: 'report/account/acknowledge/receipt', element: <AR /> }, // create acknowledgement receipt
      { path: 'report/releasing', element: <Releasing /> }, // releasing report page

      // --- Invoice processing ---
      { path: 'find/invoice', element: <FindInvoice /> },
      { path: 'process/invoice/:id', element: <ProcessInvoiceRoutes /> },
      //accounting
      { path: 'invoice', element: <Invoice /> }, // invoice list
      { path: 'customer/list', element: <CustomerList /> },
    ],
  },

  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <Navigate to="/login" /> }, // ang "/" ay dumidiretso sa login
      { path: 'login', element: <LoginView /> },
      { path: 'receipt/certificate/invoice/print/:title/:name/:eventId/:receiptNumber/:eventDate', element: <ReceiptPrint /> }, // print ng certificate at invoice

      { path: 'invoice/:eventId', element: <ReceiptPrint /> }, // invoice
      { path: '*', element: <NotFoundView /> },
    ],
  },

  {
    path: 'declarator',
    children: [
      { path: 'console', element: <Declarator /> },
      { path: 'joint/room', element: <JoinRoom /> },
    ],
  },
];

export default routes;